import { Noop } from '@eastcoal/common/types/utilities'
import { setRedirectUrl } from '@eastcoal/common/utils/browser'

export const navigateWithTarget = (navigate: Noop, to: string) => {
  navigate(setRedirectUrl(to))
}
